import * as Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueSmoothScroll from 'vue3-smooth-scroll';
import DMortgage from  '@components/organisms/DMortgage.vue';
import { VueReCaptcha } from 'vue-recaptcha-v3'

$(window).on('load', () => {
    Vue.createApp({components: {DMortgage}}).use(VueSmoothScroll).use(VueAxios, axios).use(VueReCaptcha, window.recaptchaOptions).mount('#mortgage');
});
